var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDhan = function SvgDhan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dhan_svg__a",
    x1: 22.5,
    x2: 13.932,
    y1: 20.4,
    y2: -0.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBA93",
    stopOpacity: 0.988
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#dhan_svg__a)",
    d: "M12 24a12 12 0 1 0 0-24 12 12 0 1 0 0 24m0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17875F",
    fillRule: "evenodd",
    d: "M17.441 22.695 8 15.387 9.332 12 7.074 8.922 8 6.156h9.539L24 12.031a12 12 0 0 1-6.559 10.664m0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.453 7.84h-2.738v10.813a3.5 3.5 0 0 1-1.316-.258q-.652-.234-.652-.551V15.5q-1.379.867-2.992.867c-1.613 0-1.957-.277-2.637-.828q-1.008-.844-1.008-2.187c0-.68.238-1.293.711-1.828q-1.008-.374-1.594-1.105c-.395-.496-.594-1.09-.594-1.77s.277-1.309.828-1.871q.845-.849 2.305-.848 1.063-.001 1.633.473.591.474.59 1.16 0 1.4-1.809 1.969a1.3 1.3 0 0 1-.434-.668q.804-.531.805-1.121c0-.223-.062-.402-.195-.531q-.197-.218-.629-.219c-.432-.001-.57.16-.848.473s-.414.73-.414 1.242q0 .746.414 1.258a2.33 2.33 0 0 0 1.082.691 7.7 7.7 0 0 1 1.949-.652q.75.709.945 1.48c-.812.156-1.504.406-2.066.746q-.827.494-.828 1.141 0 .631.434 1.027.453.392 1.281.391.845 0 1.672-.469a4.5 4.5 0 0 0 1.398-1.242V7.84h-1.359q-.708-.828-.707-1.754h6.164a2.8 2.8 0 0 1 .609 1.754m0 0"
  })));
};
export { SvgDhan as ReactComponent };
export default __webpack_public_path__ + "c921d5371c80e26d33710ef1f35fee60.svg";